const INITIAL_SETUP_STATUS = 'initialSetup' as 'initialSetup';
const CONFIGURED_STATUS = 'configured' as 'configured';

const TARGET_APPS = {
  INITIAL_SETUP_STATUS,
  CONFIGURED_STATUS,
};

export default TARGET_APPS;
